import { NOT_SET, track } from '@/src/utils/tracking';
import { logError } from '@/src/logger';
import getOriginEvent from '@/src/utils/tracking/getOriginEvent';
import { getScreenName, getPromisedDeliveryTimes } from './utilsTracking';

const shopImpressionsLoaded = (
  occasion,
  shopId,
  businessType,
  position,
  rankType,
  isNew,
  rankingRequestId,
  landingId,
  landingTitle,
  landingType,
  isItemLanding = false,
  ncrRequestToken = NOT_SET,
  productSku = NOT_SET,
  origin = NOT_SET,
  shopDeliveryFee = NOT_SET,
  shopDeliveryTime = NOT_SET,
  rating = NOT_SET,
) => {
  const EVENT_NAME = 'shop_impressions.loaded';

  const getVendorRankType = () => {
    const cpcRank = isItemLanding ? 'cpc' : 'FEATURED_CPC';
    const cppRank = isItemLanding ? 'cpp' : 'FEATURED_CPP';

    if (rankType === cpcRank) {
      return 'True: premium_placements__cpc';
    }

    if (rankType === cppRank) {
      return 'True: premium_placements__cpp';
    }

    return 'False';
  };

  const renderStatus = () => {
    let status = '';
    if (occasion === 'DELIVERY') {
      status += 'both,';
    } else {
      status += 'pickup,';
    }
    status += 'open,';

    if (isNew) {
      status += 'new';
    } else {
      status += 'old';
    }
    return status;
  };

  const promisedTimes = getPromisedDeliveryTimes(shopDeliveryTime);

  try {
    const payload = {
      occasion,
      impressionListName: 'campaign',
      ncrRequestToken: ncrRequestToken || NOT_SET,
      productSku: productSku || NOT_SET,
      searchTerm: NOT_SET,
      searchRequestId: NOT_SET,
      shopClickOrigin: isItemLanding
        ? getOriginEvent(origin, isItemLanding).shopClickOrigin
        : 'global_organic_list',
      eventOrigin: isItemLanding
        ? getOriginEvent(origin, isItemLanding).shopClickOrigin
        : 'global_organic_list',
      shopDeliveryFee,
      shopDeliveryTime: shopDeliveryTime || NOT_SET,
      shopId,
      shopIsFavorite: NOT_SET,
      shopListBusinessType: businessType,
      shopMinimumOrderValue: NOT_SET,
      shopPosition: position,
      shopRatingQuality: rating || NOT_SET,
      shopRatingQuantity: NOT_SET,
      shopSponsoring: getVendorRankType(),
      shopSponsoringPlacement: getOriginEvent(origin, isItemLanding)
        .shopSponsoringPlacement,
      shopStatus: renderStatus(),
      shopType: businessType,
      swimlaneStrategy: NOT_SET,
      swimlaneTitle: NOT_SET,
      screenType: isItemLanding ? 'items_landing' : 'vendors_landing',
      screenName: getScreenName(landingType),
      rankingRequestId,
      landingId,
      landingTitle,
      origin,
      ...promisedTimes,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default shopImpressionsLoaded;
